/**
 * @memberOf Tee
 * @class Colors and direction to fill areas with gradients.
 * @param {Tee.Chart} chart The parent chart this gradient object belongs to.
 */
export class Gradient {
	constructor(chart) {
		this.chart = chart
		this.visible = false

		this.colors = ["white", "silver"]
		this.direction = "topbottom"
		this.stops = null
		this.offset = { x: 0, y: 0 }
	}

	/**
	 * @returns {CanvasGradient} Returns a canvas gradient.
	 */
	create(r, color) {
		return this.rect(r.x, r.y, r.width, r.height, color)
	}

	/**
	 * @returns {CanvasGradient} Returns a canvas gradient.
	 */
	rect(x, y, width, height, color) {
		let g
		const c = this.chart.ctx
		const l = c.createLinearGradient

		if (this.direction === "topbottom") {
			g = l.call(c, x, y, x, y + height)
		} else if (this.direction === "bottomtop") {
			g = l.call(c, x, y + height, x, y)
		} else if (this.direction === "leftright") {
			g = l.call(c, x, y, x + width, y)
		} else if (this.direction === "rightleft") {
			g = l.call(c, x + width, y, x, y)
		} else if (this.direction === "radial") {
			const px = x + width * 0.5 + this.offset.x
			const py = y + height * 0.5 + this.offset.y
			const rad = Math.max(width, height)

			g = c.createRadialGradient(px, py, 0, px, py, rad)
		} else if (this.direction === "diagonalup") {
			g = l.call(c, x, y + height, x + width, y)
		} else {
			g = l.call(c, x, y, x + width, y + height)
		}

		if (color) {
			this.setEndColor(color)
		}

		const colors = this.colors
		const len = colors.length
		const stops = this.stops
		const stopCount = stops ? stops.length : 0

		if (len > 1) {
			for (let t = 0; t < len; t++) {
				g.addColorStop(stopCount <= t ? t / (len - 1) : stops[t], colors[t])
			}
		} else {
			g.addColorStop(0, len > 0 ? colors[0] : "white")
		}

		return g
	}

	/**
	 * Sets color to all gradient colors except first color.
	 * @param {Color} color The color to set.
	 */
	setEndColor(color) {
		if (color && color !== "") {
			for (let t = 1, l = this.colors.length; t < l; t++) {
				this.colors[t] = color
			}
		}
	}
}
